import { render, staticRenderFns } from "./AdminFavourites.vue?vue&type=template&id=3a2072b5"
import script from "./AdminFavourites.vue?vue&type=script&lang=js"
export * from "./AdminFavourites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AdminFavourites.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a2072b5')) {
      api.createRecord('3a2072b5', component.options)
    } else {
      api.reload('3a2072b5', component.options)
    }
    module.hot.accept("./AdminFavourites.vue?vue&type=template&id=3a2072b5", function () {
      api.rerender('3a2072b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/AdminFavourites.vue"
export default component.exports